// This file is generated by pnpm icons:generate. Do not edit.

import {CirclePlus_Stroke2_Corner0_Rounded as CanonicalCirclePlus_Stroke2_Corner0_Rounded} from './Circle'

/** @deprecated Import CirclePlus_Stroke2_Corner0_Rounded from `#/components/icons/Circle` instead. */
export const CirclePlus_Stroke2_Corner0_Rounded =
  CanonicalCirclePlus_Stroke2_Corner0_Rounded
